module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    staticClass: "mw7-ns center-ns"
  }, [_c('br'), _vm._v(" "), (_vm.emailError) ? _c('div', {
    staticClass: "f6 mb3 red tc error"
  }, [_vm._v("\n    A user with this email already exists.\n    Please verify your entry or\n    "), _c('a', {
    staticClass: "color-theme underline dib",
    attrs: {
      "href": "mailto:support@getakko.com"
    }
  }, [_vm._v("contact support")])]) : (_vm.phoneError) ? _c('div', {
    staticClass: "f6 mb3 red tc error"
  }, [_vm._v("\n    A user with this phone number already exists.\n    Please verify your entry or\n    "), _c('a', {
    staticClass: "color-theme underline dib",
    attrs: {
      "href": "mailto:support@getakko.com"
    }
  }, [_vm._v("contact support")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "mt4 mb4 pt4 grid-half"
  }, [_c('div', [_c('label', {
    staticClass: "f6 b db mb2",
    attrs: {
      "for": "email"
    }
  }, [_vm._v("Email Address")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }, {
      name: "focus",
      rawName: "v-focus"
    }],
    staticClass: "input-reset ba b--black-20 pa2 mb2 db w-100 br1",
    attrs: {
      "id": "email",
      "name": "email",
      "type": "email",
      "autocomplete": "email"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "blur": _vm.checkEmail,
      "focus": function($event) {
        _vm.email_unfocused = false
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', [_c('label', {
    staticClass: "f6 b db mb2",
    attrs: {
      "for": "phone_no"
    }
  }, [_vm._v("Phone number")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.phone_no),
      expression: "phone_no"
    }],
    staticClass: "input-reset ba b--black-20 pa2 mb2 db w-100 br1",
    attrs: {
      "id": "phone_no",
      "name": "phone_no",
      "maxlength": "11"
    },
    domProps: {
      "value": (_vm.phone_no)
    },
    on: {
      "blur": _vm.setPhoneNo,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.phone_no = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.phone_unfocused && _vm.phone_no !== '' && !_vm.isValidPhone(_vm.phone_no)),
      expression: "phone_unfocused && phone_no !== '' && !isValidPhone(phone_no)"
    }],
    staticClass: "red f7 mt2"
  }, [_vm._v("\n      Must use a valid phone number\n    ")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errorList.length > 0),
      expression: "errorList.length > 0"
    }],
    staticClass: "mb3"
  }, [_c('span', {
    staticClass: "red"
  }, [_vm._v("Error submitting registration:")]), _vm._v(" "), _vm._l((_vm.errorList), function(e, index) {
    return _c('span', {
      key: index,
      staticClass: "red"
    }, [_vm._v(_vm._s(e))])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "f5 db mb3"
  }, [_vm._v("Payment Information")]), _vm._v(" "), _c('div', {
    staticClass: "mt4 mb4 grid-half"
  }, [_c('div', [_c('label', {
    staticClass: "f6 b db mb2",
    attrs: {
      "for": "first_name"
    }
  }, [_vm._v("Cardholder First Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.first_name),
      expression: "first_name"
    }],
    staticClass: "input-reset ba b--black-20 pa2 mb2 db w-100 br1",
    attrs: {
      "id": "first_name",
      "name": "first_name",
      "type": "text"
    },
    domProps: {
      "value": (_vm.first_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.first_name = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.registration.coverage.name.toLowerCase().includes('monthly')) ? _c('div', {
    staticClass: "f6 i mb4"
  }) : _vm._e()]), _vm._v(" "), _c('div', [_c('label', {
    staticClass: "f6 b db mb2",
    attrs: {
      "for": "last_name"
    }
  }, [_vm._v("Cardholder Last Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.last_name),
      expression: "last_name"
    }],
    staticClass: "input-reset ba b--black-20 pa2 mb2 db w-100 br1",
    attrs: {
      "id": "last_name",
      "name": "last_name",
      "type": "text"
    },
    domProps: {
      "value": (_vm.last_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.last_name = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', [_vm._m(0), _vm._v(" "), _c('div', {
    attrs: {
      "id": "card-element"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "red f7 mt2",
    attrs: {
      "id": "card-errors",
      "role": "alert"
    }
  }), _vm._v(" "), (_vm.generalError) ? _c('div', {
    staticClass: "red f6 mt2",
    attrs: {
      "role": "alert"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.generalError) + "\n    ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "f6 silver mv2"
  }, [_vm._v("All major credit cards accepted")]), _vm._v(" "), _c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "width": "119px",
      "height": "26px"
    }
  }, [_c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "opacity": "0.502",
      "fill": "rgb(66, 71, 112)",
      "d": "M113.000,26.000 L6.000,26.000 C2.686,26.000 0.000,23.314 0.000,20.000 L0.000,6.000 C0.000,2.686 2.686,-0.000 6.000,-0.000 L113.000,-0.000 C116.314,-0.000 119.000,2.686 119.000,6.000 L119.000,20.000 C119.000,23.314 116.314,26.000 113.000,26.000 ZM11.128,8.892 L8.571,8.892 L8.571,16.133 L9.918,16.133 L9.918,13.533 L11.128,13.533 C12.602,13.533 13.654,12.586 13.654,11.218 C13.654,9.850 12.602,8.892 11.128,8.892 ZM17.043,10.745 C15.454,10.745 14.328,11.881 14.328,13.502 C14.328,15.112 15.454,16.259 17.043,16.259 C18.632,16.259 19.748,15.112 19.748,13.502 C19.748,11.881 18.632,10.745 17.043,10.745 ZM26.936,10.871 L25.873,14.449 L24.810,10.871 L23.590,10.871 L22.527,14.449 L21.464,10.871 L20.117,10.871 L21.927,16.133 L23.137,16.133 L24.200,12.555 L25.274,16.133 L26.484,16.133 L28.283,10.871 L26.936,10.871 ZM31.252,10.745 C29.747,10.745 28.653,11.871 28.653,13.460 C28.653,15.101 29.768,16.259 31.357,16.259 C31.946,16.259 32.546,16.122 33.146,15.849 L33.146,14.722 C32.599,15.038 32.062,15.217 31.578,15.217 C30.694,15.217 30.063,14.670 29.978,13.870 L33.546,13.870 C33.567,13.691 33.567,13.523 33.567,13.375 C33.567,11.829 32.630,10.745 31.252,10.745 ZM37.724,10.797 C37.577,10.755 37.430,10.745 37.282,10.745 C36.830,10.745 36.367,10.976 35.988,11.397 L35.988,10.871 L34.641,10.871 L34.641,16.133 L35.988,16.133 L35.988,12.618 C36.335,12.176 36.809,11.934 37.251,11.934 C37.409,11.934 37.577,11.955 37.724,11.997 L37.724,10.797 ZM40.808,10.745 C39.303,10.745 38.209,11.871 38.209,13.460 C38.209,15.101 39.325,16.259 40.914,16.259 C41.503,16.259 42.103,16.122 42.703,15.849 L42.703,14.722 C42.155,15.038 41.619,15.217 41.134,15.217 C40.251,15.217 39.619,14.670 39.535,13.870 L43.102,13.870 C43.123,13.691 43.123,13.523 43.123,13.375 C43.123,11.829 42.187,10.745 40.808,10.745 ZM48.912,8.566 L47.554,8.566 L47.554,11.229 C47.144,10.913 46.681,10.745 46.218,10.745 C44.818,10.745 43.840,11.881 43.840,13.502 C43.840,15.122 44.818,16.259 46.218,16.259 C46.681,16.259 47.144,16.091 47.554,15.764 L47.554,16.133 L48.912,16.133 L48.912,8.566 ZM55.690,10.745 C55.238,10.745 54.775,10.913 54.354,11.229 L54.354,8.566 L53.007,8.566 L53.007,16.133 L54.354,16.133 L54.354,15.764 C54.775,16.091 55.238,16.259 55.690,16.259 C57.100,16.259 58.068,15.122 58.068,13.502 C58.068,11.881 57.100,10.745 55.690,10.745 ZM62.310,10.871 L61.037,14.323 L59.774,10.871 L58.395,10.871 L60.405,15.943 L59.395,18.437 L60.700,18.437 L63.689,10.871 L62.310,10.871 ZM73.109,10.288 C73.972,10.288 75.069,10.552 75.933,11.019 L75.933,8.344 C74.992,7.969 74.052,7.825 73.111,7.825 C70.808,7.825 69.273,9.028 69.273,11.038 C69.273,14.181 73.589,13.671 73.589,15.026 C73.589,15.551 73.133,15.721 72.500,15.721 C71.559,15.721 70.345,15.332 69.392,14.814 L69.392,17.525 C70.448,17.979 71.518,18.169 72.497,18.169 C74.858,18.169 76.485,17.003 76.485,14.959 C76.485,11.573 72.144,12.181 72.144,10.903 C72.144,10.460 72.514,10.288 73.109,10.288 ZM82.180,8.014 L80.024,8.014 L80.022,5.548 L77.250,6.138 L77.237,15.247 C77.237,16.928 78.502,18.169 80.187,18.169 C81.115,18.169 81.801,18.001 82.179,17.793 L82.179,15.482 C81.816,15.627 80.024,16.148 80.024,14.475 L80.024,10.435 L82.180,10.435 L82.180,8.014 ZM88.275,8.015 C87.897,7.879 86.570,7.631 85.905,8.853 L85.727,8.014 L83.272,8.014 L83.272,17.966 L86.110,17.966 L86.110,11.219 C86.781,10.338 87.914,10.508 88.275,10.625 L88.275,8.015 ZM91.999,4.230 L89.149,4.836 L89.149,7.149 L91.999,6.543 L91.999,4.230 ZM91.999,8.014 L89.149,8.014 L89.149,17.966 L91.999,17.966 L91.999,8.014 ZM98.125,7.825 C97.012,7.825 96.293,8.349 95.901,8.715 L95.753,8.014 L93.253,8.014 L93.254,21.268 L96.093,20.664 L96.099,17.451 C96.507,17.750 97.114,18.169 98.108,18.169 C100.139,18.169 101.997,16.535 101.997,12.927 C101.997,9.621 100.119,7.825 98.125,7.825 ZM107.049,7.825 C104.348,7.825 102.704,10.121 102.704,13.013 C102.704,16.437 104.642,18.169 107.408,18.169 C108.765,18.169 109.784,17.861 110.555,17.433 L110.555,15.146 C109.781,15.536 108.893,15.774 107.766,15.774 C106.659,15.774 105.684,15.382 105.557,14.051 L111.116,14.051 C111.129,13.898 111.154,13.303 111.154,13.028 C111.154,10.120 109.746,7.825 107.049,7.825 ZM107.031,10.140 C107.728,10.140 108.468,10.677 108.468,11.955 L105.532,11.955 C105.532,10.676 106.321,10.140 107.031,10.140 ZM97.446,15.661 C96.780,15.661 96.383,15.421 96.107,15.122 L96.090,10.903 C96.386,10.578 96.795,10.340 97.446,10.340 C98.485,10.340 99.200,11.504 99.200,12.989 C99.200,14.518 98.496,15.661 97.446,15.661 ZM55.406,15.101 C55.038,15.101 54.669,14.943 54.354,14.628 L54.354,12.376 C54.669,12.060 55.038,11.902 55.406,11.902 C56.164,11.902 56.690,12.555 56.690,13.502 C56.690,14.449 56.164,15.101 55.406,15.101 ZM46.513,15.101 C45.744,15.101 45.218,14.449 45.218,13.502 C45.218,12.555 45.744,11.902 46.513,11.902 C46.881,11.902 47.249,12.060 47.554,12.376 L47.554,14.628 C47.249,14.943 46.881,15.101 46.513,15.101 ZM40.756,11.786 C41.355,11.786 41.787,12.281 41.829,12.997 L39.535,12.997 C39.598,12.271 40.103,11.786 40.756,11.786 ZM31.199,11.786 C31.799,11.786 32.231,12.281 32.273,12.997 L29.978,12.997 C30.042,12.271 30.547,11.786 31.199,11.786 ZM17.043,15.133 C16.254,15.133 15.707,14.470 15.707,13.502 C15.707,12.534 16.254,11.871 17.043,11.871 C17.822,11.871 18.369,12.534 18.369,13.502 C18.369,14.470 17.822,15.133 17.043,15.133 ZM10.939,12.439 L9.918,12.439 L9.918,9.987 L10.939,9.987 C11.718,9.987 12.265,10.482 12.265,11.218 C12.265,11.944 11.718,12.439 10.939,12.439 Z"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "mt4"
  }, [_c('label', {
    staticClass: "f6 b db mb2",
    attrs: {
      "for": "promo_code"
    }
  }, [_vm._v("\n      Discount Code\n      "), (_vm.$store.state.registration.promo.status == 'valid') ? _c('span', {
    staticStyle: {
      "color": "green"
    }
  }, [_vm._v(" - VALID ($" + _vm._s((_vm.discount_in_months / 100)) + " OFF)")]) : (_vm.$store.state.registration.promo.status == 'invalid') ? _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(" - INVALID")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "input-group-flex mb2"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.promo_code),
      expression: "promo_code"
    }],
    staticClass: "input-reset ba b--black-20 pa2 db w-100 br1 ttu",
    attrs: {
      "id": "promo_code",
      "type": "text"
    },
    domProps: {
      "value": (_vm.promo_code)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.checkPromoCode.apply(null, arguments)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.promo_code = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "f6 link dim ba bw2 ph3 pv2 dib dark-green submit-btn",
    on: {
      "click": _vm.checkPromoCode
    }
  }, [_vm._v("Submit")])]), _vm._v(" "), (_vm.coverage.name.toLowerCase().includes('monthly')) ? _c('div', {
    staticClass: "f6 i mb4"
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "mb2 f6"
  }, [_c('div', {
    staticClass: "silver mb2"
  }, [_vm._v("Checkout:")]), _vm._v(" "), _c('div', {
    staticClass: "black lh-copy"
  }, [_vm._v("AKKO Adult Plan: $" + _vm._s(_vm.coverage.price))]), _vm._v(" "), (_vm.activation_fee) ? _c('div', {
    staticClass: "black lh-copy"
  }, [_vm._v("Activation Fee (one-time): +$" + _vm._s(_vm.$store.state.registration.activation_fee.value))]) : _vm._e(), _vm._v(" "), (_vm.discount) ? _c('div', {
    staticClass: "black lh-copy"
  }, [_vm._v("\n      Discount Code: -$" + _vm._s(_vm.discount_in_months / 100) + "\n    ")]) : _vm._e(), _vm._v(" "), (_vm.activation_fee || _vm.discount) ? _c('div', {
    staticClass: "black lh-copy mt3"
  }, [_vm._v("Total: $" + _vm._s(_vm.cardCharge) + " (" + _vm._s(_vm.selectedCountryCurrency.currency_code) + ")")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "mv3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accept),
      expression: "accept"
    }],
    staticClass: "di",
    attrs: {
      "id": "accept",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.accept) ? _vm._i(_vm.accept, null) > -1 : (_vm.accept)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.accept,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.accept = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.accept = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.accept = $$c
        }
      }
    }
  }), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('div', {
    staticClass: "mv4 flex justify-center"
  }, [_c('ak-button', {
    staticClass: "flex-grow flex-grow-off-ns",
    attrs: {
      "disabled": !_vm.stepComplete || _vm.loading,
      "green": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.submit.apply(null, arguments)
      }
    }
  }, [_vm._v("\n      Register\n    ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "black f6 mv4 mw7-ns center tc lh-copy"
  }, [_vm._v("\n    Elite Risk Insurance Solutions Lic#0G40499. ")])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "f6 b db mb2",
    attrs: {
      "for": "card-element"
    }
  }, [_c('span', [_vm._v("Credit or Debit Card")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "f6 fw5 di mb2 lh-copy",
    attrs: {
      "for": "accept"
    }
  }, [_vm._v("\n      I agree that I have thoroughly read, understand, and accept the\n      "), _c('a', {
    staticClass: "color-theme",
    attrs: {
      "href": "https://getakko.com/legal",
      "target": "_blank"
    }
  }, [_vm._v("terms of service & conditions")]), _vm._v("\n      as well as the "), _c('a', {
    staticClass: "color-theme",
    attrs: {
      "href": "https://getakko.com/coverage-info-faqs/",
      "target": "_blank",
      "rel": "noopener"
    }
  }, [_vm._v("AKKO website's FAQs")]), _vm._v(" about plan protections and claims.\n      I also acknowledge and agree to receive and view all plan documentation, including Terms and Conditions and Plan Confirmation (if any), electronically as well as receive automated transactional messages via email and SMS in accordance with AKKO's Privacy Policy.\n      "), _c('br'), _vm._v(" "), _c('br')])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-8f64a448", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8f64a448","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/registration/AdultReviewAndSubmit.vue
// module id = 640
// module chunks = 0